export default __webpack_public_path__ + "static/media/bed.db3cd21f.svg";